export const ICON_STYLES = {
    sm: { width: 80, height: 80 },
    md: {},
};

export const ICON_WRAPPER_STYLES = {
    sm: { width: 120, height: 120, margin: '10px auto' },
    md: {},
};